export default __webpack_public_path__ + "maps-examples-select-layer-thumbnail-480-e49942b4ab4b67fb0923e4843f0492de.webp";